<form novalidate #updateLoginId="ngForm" (ngSubmit)="submit(updateLoginId)">
  <div class="modal-body">
    <div class="form-group row">
      <label class="col-md-12 col-form-label">現在のログインID：{{ member.loginId }}</label>
      <label class="col-md-12 col-form-label">ログインID</label>
      <div class="col-md-12">
        <input [disabled]="busy || blocked" type="text" class="form-control" [(ngModel)]="newLoginId" name="newLoginId" required [pattern]="loginIdReg" placeholder="ログインID: 半角数字と記号（「-」「_」「.」のみ）">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn bg-close text-white" type="button" (click)="cancel.emit()" [disabled]="busy"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
    <button class="btn btn-success" type="submit" [disabled]="updateLoginId.invalid || updateLoginId.pending || busy || blocked"><i class="fa s-icon-save"></i>&nbsp;保存</button>
  </div>
</form>
